export function steps (key, { responsive, t } = {}) {
    return {
        'leaderboard-1': [
            {
                attachTo: { element: `#leaderboard-current-user`, placement: 'top' },
                content: {
                    title: 'Your current rank',
                    description: 'You earn neurons in different roles.',
                },
            },
            {
                attachTo: { element: `#leaderboard-sorting-col`, placement: 'top' },
                content: {
                    title: 'Sorting',
                    description: 'Sort by Game Roles.',
                },
            },
        ],
        'leaderboard-2': [
        ],
        'home-page': [
            {
                attachTo: {
                    element: '#widget-gamedash',
                    placement: responsive?.mobile ? 'top' : 'left'
                },
                content: {
                    title: t?.(`onboarding.home-page.widget-gamedash.title`) ?? '',
                    description: t?.(`onboarding.home-page.widget-gamedash.description`) ?? '',
                },
            },
            {
                attachTo: {
                    element: '#open-challenges',
                    placement: 'top',
                },
                content: {
                    title: t?.(`onboarding.home-page.open-challenges.title`) ?? '',
                    description: t?.(`onboarding.home-page.open-challenges.description`) ?? '',
                },
                options: {
                    modifiers: [ { name: 'offset', options: { offset: [0, -60] } }],
                },
            },
            {
                attachTo: {
                    element: `#challenge-filters`,
                    placement: 'top'
                },
                content: {
                    title: t?.(`onboarding.home-page.challenge-filters.title`) ?? '',
                    description: t?.(`onboarding.home-page.challenge-filters.description`) ?? '',
                },
            },
            {
                attachTo: {
                    element: '#categories-picker',
                    placement: responsive?.mobile ? 'top' : 'bottom'
                },
                content: {
                    title: t?.(`onboarding.home-page.categories-picker.title`) ?? '',
                    description: t?.(`onboarding.home-page.categories-picker.description`) ?? '',
                },
            },
            {
                attachTo: {
                    element: '#widget-olympiads',
                    placement: responsive?.mobile ? 'top' : 'left'
                },
                content: {
                    title: t?.(`onboarding.home-page.widget-olympiads.title`) ?? '',
                    description: t?.(`onboarding.home-page.widget-olympiads.description`) ?? '',
                },
            },
        ],
        'innovator-dashboard': [
            {
                attachTo: { element: `#your-current-rank`, placement: 'top' },
                content: {
                    title: 'Your current rank',
                    description: 'As the crowd rates your ideas your ranking will change.',
                },
            },
            {
                attachTo: { element: `#your-rating-rank`, placement: 'top' },
                content: {
                    title: 'Your Rating Rank',
                    description: 'Rate more in your Analyst Dashboard.',
                },
            },
            {
                attachTo: {
                    element: '#app-navbar',
                    placement: responsive?.mobile ? 'top' : 'bottom'
                },
                content: {
                    title: t?.(`onboarding.home-page.app-navbar.title`) ?? '',
                    description: t?.(`onboarding.home-page.app-navbar.description`) ?? '',
                },
            },
        ],
    }[key];
}
